<div class="sage-page" *ngIf="!loading">
  <!-- On a phone this scrolls on its own, above the pinned footer; on desktop it isn't a box at all. -->
  <div class="review-scroll" #reviewScroll>
  <div class="page-header">
    <div class="title-row">
      <button class="back-btn" (click)="goBack()"><i class="bi bi-arrow-left"></i></button>
      <div>
        <h1 class="page-title">{{ entityLabel }}</h1>
        <p class="page-subtitle">Match each Sage record to the same record in AIVOR</p>
      </div>
    </div>
    <div class="user-block" *ngIf="fullName">
      <span class="user-label">Current User:</span>
      <div class="user-name">{{ fullName }}</div>
      <div class="user-tenant">{{ tenantName }}</div>
    </div>
  </div>

  <div class="alert-banner" *ngIf="loadError">
    <i class="bi bi-exclamation-circle"></i>
    {{ loadErrorMessage }}
    <button class="btn btn-teal-gradient" (click)="retryLoad()">Retry</button>
  </div>

  <ng-container *ngIf="!loadError">
  <!-- Filter bar -->
  <div class="filter-bar">
    <div class="filter-chips">
    <button class="chip" [class.active]="activeFilter === 'all'" (click)="setFilter('all'); revealChip($event)">
      All <span class="count-badge">{{ filterCounts.all }}</span>
    </button>
    <button class="chip" [class.active]="activeFilter === 'review'" (click)="setFilter('review'); revealChip($event)">
      Needs review <span class="count-badge">{{ filterCounts.review }}</span>
    </button>
    <button class="chip" [class.active]="activeFilter === 'confirmed'" (click)="setFilter('confirmed'); revealChip($event)">
      Confirmed <span class="count-badge">{{ filterCounts.confirmed }}</span>
    </button>
    <button class="chip" [class.active]="activeFilter === 'new-in-sage'" (click)="setFilter('new-in-sage'); revealChip($event)">
      New in Sage <span class="count-badge">{{ filterCounts['new-in-sage'] }}</span>
    </button>
    <button class="chip" [class.active]="activeFilter === 'new-in-aivor'" (click)="setFilter('new-in-aivor'); revealChip($event)">
      New in AIVOR <span class="count-badge">{{ filterCounts['new-in-aivor'] }}</span>
    </button>
    </div>

    <div class="search-row">
    <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search records" [(ngModel)]="searchQuery" />
    </div>
    <button class="btn btn-secondary" (click)="confirmAllShown()">
      <i class="bi bi-check2-all"></i> <span class="d-none d-md-inline">Confirm all shown</span><span class="d-md-none">Confirm all</span>
    </button>
    </div>
  </div>

  <!-- Table -->
  <div class="table-card" *ngIf="filteredRows.length > 0">
    <div class="table-scroll">
      <div class="table-row header-row">
        <div>SAGE RECORD</div>
        <div></div>
        <div>AIVOR RECORD</div>
        <div>CONFIDENCE</div>
        <div>STATUS</div>
        <div class="action-col">ACTION</div>
      </div>

      <ng-container *ngFor="let row of filteredRows">
        <div class="table-row body-row" [class.expanded]="row.expanded" (click)="toggleExpand(row)">
          <div class="sage-cell">
            <div class="record-name" [class.absent]="!row.match.sageRecordId">{{ row.sageName }}</div>
            <div class="record-meta">{{ row.sageMeta }}</div>
          </div>
          <div class="aivor-block">
          <div class="arrow-col">
            <i class="bi" [class.bi-arrow-left-right]="row.match.sageRecordId" [class.bi-plus-lg]="!row.match.sageRecordId"></i>
          </div>
          <div class="aivor-cell">
            <div class="record-name" [class.absent]="!aivorIdOf(row)">{{ row.aivorName }}</div>
            <div class="record-meta">{{ row.aivorMeta }}</div>
            <div class="match-reason" *ngIf="row.uiStatus === 'review' && row.matchReason">{{ row.matchReason }}</div>
            <div class="sync-target-toggle" *ngIf="entityType === 'ItemBundle' && row.aivorRaw" (click)="$event.stopPropagation()">
              <button type="button" class="sync-target-segment" [class.active]="syncTarget(row) === 'Bundle'" [attr.aria-pressed]="syncTarget(row) === 'Bundle'" (click)="setSyncTarget(row, 'Bundle')">Bundle</button>
              <button type="button" class="sync-target-segment" [class.active]="syncTarget(row) === 'Standalone'" [attr.aria-pressed]="syncTarget(row) === 'Standalone'" (click)="setSyncTarget(row, 'Standalone')">Standalone</button>
            </div>
            <div class="dependency-warning" *ngIf="bundleBlockedWarning(row) as warning">
              <i class="bi bi-exclamation-triangle-fill"></i> {{ warning }}
            </div>
          </div>
          </div>

          <div class="confidence-cell">
            <ng-container *ngIf="row.confidence !== null">
              <div class="confidence-value" [ngClass]="{
                'c-high': row.confidence >= 92,
                'c-mid': row.confidence >= 75 && row.confidence < 92,
                'c-low': row.confidence < 75
              }">{{ row.confidence | number: '1.0-0' }}%</div>
              <div class="confidence-track">
                <div class="confidence-fill" [style.width.%]="row.confidence" [ngClass]="{
                  'c-high': row.confidence >= 92,
                  'c-mid': row.confidence >= 75 && row.confidence < 92,
                  'c-low': row.confidence < 75
                }"></div>
              </div>
            </ng-container>
            <span class="dash" *ngIf="row.confidence === null">-</span>
          </div>
          <div class="status-cell">
            <span class="status-pill" [ngClass]="'status-' + row.uiStatus">
              {{ needsUomMapping(row) ? 'Unit needs matching'
                : row.uiStatus === 'confirmed' ? 'Confirmed'
                : row.uiStatus === 'review' ? 'Needs review'
                : row.uiStatus === 'new-in-aivor' ? 'Create in AIVOR'
                : 'Create in Sage' }}
            </span>
          </div>
          <div class="action-col">
            <button class="btn btn-teal-gradient btn-sm" *ngIf="row.uiStatus === 'review' && !needsUomMapping(row) && !row.aivorMissing" (click)="$event.stopPropagation(); confirmRow(row)">Confirm</button>
            <button class="btn btn-secondary btn-sm" (click)="$event.stopPropagation(); toggleExpand(row)">
              {{ row.expanded ? 'Close' : (aivorIdOf(row) ? 'Change' : 'Find match') }}
              <i class="bi" [class.bi-chevron-down]="!row.expanded" [class.bi-chevron-up]="row.expanded"></i>
            </button>
          </div>
        </div>

        <div class="details-panel" *ngIf="row.expanded" (click)="$event.stopPropagation()">

          <!-- Items configuration panel (§2) -->
          <div class="config-panel" *ngIf="entityType === 'Item'" [class.config-panel-amber]="row.uomSource === 'guess'">
            <div class="config-panel-heading">
              <i class="bi" [class.bi-exclamation-triangle-fill]="row.uomSource === 'guess'" [class.bi-sliders]="row.uomSource !== 'guess'"></i>
              <span *ngIf="row.uomSource === 'guess'">Check the unit of measure - no exact Sage match for &ldquo;{{ sageUnitFor(row) }}&rdquo;</span>
              <span *ngIf="row.uomSource !== 'guess'">Item configuration</span>
            </div>
            <div class="config-panel-controls">
              <div class="config-control">
                <div class="config-control-label">Item type <span class="config-control-qualifier" *ngIf="row.selectedItemTypeId === 1 && !isSageServiceRow(row)">default</span></div>
                <ng-container *ngIf="isSageServiceRow(row); else itemTypePicker">
                  <div class="config-control-value">Service</div>
                  <div class="config-control-hint">Sage services come into Aivor as services</div>
                </ng-container>
                <ng-template #itemTypePicker>
                  <div class="segmented-control">
                    <button type="button" class="segmented-option" [class.active]="row.selectedItemTypeId === 1" [attr.aria-pressed]="row.selectedItemTypeId === 1" (click)="setItemType(row, 1)">Raw material</button>
                    <button type="button" class="segmented-option" [class.active]="row.selectedItemTypeId === 2" [attr.aria-pressed]="row.selectedItemTypeId === 2" (click)="setItemType(row, 2)">Finished good</button>
                    <!-- Variable items are held back from Sage for now (SageItemPayloadHelpers.IsKeptOutOfSage); restore this option if that's lifted.
                    <button type="button" class="segmented-option" [class.active]="row.selectedItemTypeId === 3" [attr.aria-pressed]="row.selectedItemTypeId === 3" (click)="setItemType(row, 3)">Variable item</button>
                    -->
                  </div>
                  <div class="config-control-hint">{{ itemTypeHint(row) }}</div>
                </ng-template>
              </div>
              <div class="config-control">
                <div class="config-control-label">Unit of measure</div>
                <div class="config-control-inline">
                  <select
                    class="details-field-select config-control-select"
                    [(ngModel)]="row.selectedUomId"
                    (ngModelChange)="resolveUomForRow(row)"
                  >
                    <option [ngValue]="null">Select a Sage unit…</option>
                    <option *ngFor="let uom of uomOptions" [ngValue]="uom.id">{{ uom.code }} - {{ uom.name }}</option>
                  </select>
                  <button
                    class="btn btn-teal-gradient btn-sm"
                    *ngIf="needsUomMapping(row)"
                    [disabled]="!row.selectedUomId"
                    (click)="resolveUomForRow(row)"
                  >
                    Confirm unit
                  </button>
                </div>
                <div class="config-control-hint" [ngClass]="'uom-hint-' + row.uomSource">
                  <span class="uom-qualifier" [ngClass]="'uom-qualifier-' + row.uomSource">{{ uomQualifier(row) }}</span>
                  {{ uomHint(row) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Item Bundles configuration panel (§3) -->
          <div class="config-panel" *ngIf="entityType === 'ItemBundle' && row.aivorRaw" [class.config-panel-amber]="bundleBlockedWarning(row)">
            <div class="config-panel-heading">
              <i class="bi" [class.bi-exclamation-triangle-fill]="bundleBlockedWarning(row)" [class.bi-sliders]="!bundleBlockedWarning(row)"></i>
              <span *ngIf="bundleBlockedWarning(row)">Can't send to Sage yet - see below</span>
              <span *ngIf="!bundleBlockedWarning(row)">How it's sent to Sage</span>
            </div>
            <div class="config-panel-controls">
              <div class="config-control">
                <div class="config-control-label">Send to Sage as</div>
                <div class="segmented-control segmented-control-two">
                  <button type="button" class="segmented-option" [class.active]="syncTarget(row) === 'Bundle'" [attr.aria-pressed]="syncTarget(row) === 'Bundle'" (click)="setSyncTarget(row, 'Bundle')">Bundle</button>
                  <button type="button" class="segmented-option" [class.active]="syncTarget(row) === 'Standalone'" [attr.aria-pressed]="syncTarget(row) === 'Standalone'" (click)="setSyncTarget(row, 'Standalone')">Standalone</button>
                </div>
                <div class="config-control-hint">{{ syncTargetHint(row) }}</div>
              </div>
              <div class="config-control">
                <div class="config-control-label">Made from</div>
                <div class="component-dependency-header" (click)="$event.stopPropagation(); toggleComponentTable(row)">
                  <span class="component-dependency-count" [class.ready]="!bundleBlockedWarning(row)">
                    {{ (row.aivorRaw.bundleInfo?.componentCount ?? 0) - (row.aivorRaw.bundleInfo?.blockedComponentCount ?? 0) }}
                    of {{ row.aivorRaw.bundleInfo?.componentCount ?? 0 }} ready
                  </span>
                  <div class="component-dependency-track">
                    <div
                      class="component-dependency-fill"
                      [class.ready]="!bundleBlockedWarning(row)"
                      [style.width.%]="row.aivorRaw.bundleInfo?.componentCount ? (((row.aivorRaw.bundleInfo.componentCount - (row.aivorRaw.bundleInfo.blockedComponentCount ?? 0)) / row.aivorRaw.bundleInfo.componentCount) * 100) : 100"
                    ></div>
                  </div>
                  <span class="component-dependency-toggle">
                    {{ row.componentTableOpen ? 'Hide' : 'Show' }}
                    <i class="bi" [class.bi-chevron-down]="!row.componentTableOpen" [class.bi-chevron-up]="row.componentTableOpen"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="component-dependency-table" *ngIf="row.componentTableOpen">
              <div class="component-dependency-row" *ngFor="let c of row.componentRows">
                <span class="component-dependency-name">{{ c.itemName || '-' }}</span>
                <span class="component-dependency-code">{{ c.itemCode || '-' }}</span>
                <span class="component-dependency-state">
                  <i class="bi bi-check-lg" *ngIf="c.hasSageItemId"></i>
                  <span class="component-dependency-nomatch" *ngIf="!c.hasSageItemId">Not in Sage yet</span>
                </span>
              </div>
            </div>
            <div class="dependency-warning dependency-warning-inline" *ngIf="bundleBlockedWarning(row) as warning">
              <i class="bi bi-exclamation-triangle-fill"></i> {{ warning }}
            </div>
          </div>

          <!-- Sage record | AIVOR record | Change AIVOR match -->
          <div class="details-boxes-row">
            <div class="details-box details-box-sage">
              <div class="details-box-heading">Sage record</div>
              <div class="details-field" *ngFor="let m of mappingRowsFor(row)">
                <span class="details-field-label">{{ m.sageLabel }}</span>
                <span class="details-field-value">{{ m.sageValue }}</span>
              </div>
              <ng-container *ngIf="entityType === 'Item'">
                <div class="details-field">
                  <span class="details-field-label">Unit of Measure</span>
                  <span class="details-field-value">{{ sageUnitFor(row) }}</span>
                </div>
                <div class="details-field">
                  <span class="details-field-label">Sales group</span>
                  <span class="details-field-value">{{ sageReportGroupFor(row) }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="entityType === 'ItemBundle'">
                <div class="details-field">
                  <span class="details-field-label">Active bill of materials</span>
                  <span class="details-field-value absent">-</span>
                </div>
              </ng-container>
            </div>
            <div class="details-box details-box-aivor">
              <div class="details-box-heading">AIVOR record</div>
              <div class="details-field" *ngFor="let m of mappingRowsFor(row)">
                <span class="details-field-label">{{ m.aivorLabel }}</span>
                <span class="details-field-value">{{ m.aivorValue }}</span>
              </div>
              <ng-container *ngIf="entityType === 'Item'">
                <div class="details-field">
                  <span class="details-field-label">Unit of Measure</span>
                  <span class="details-field-value" [class.uom-value-guess]="row.uomSource === 'guess'">
                    {{ selectedUomLabel(row) }}
                  </span>
                </div>
                <div class="details-field">
                  <span class="details-field-label">Sales group</span>
                  <span class="details-field-value">-</span>
                </div>
              </ng-container>
              <ng-container *ngIf="entityType === 'ItemBundle'">
                <div class="details-field">
                  <span class="details-field-label">Components</span>
                  <span class="details-field-value">{{ row.aivorRaw?.bundleInfo?.componentCount ?? '-' }}</span>
                </div>
              </ng-container>
            </div>
            <div class="candidate-search-col" *ngIf="row.match.sageRecordId && !needsUomMapping(row)">
              <div class="candidate-search-label">Change AIVOR match</div>
              <div class="candidate-search-box">
                <i class="bi bi-search"></i>
                <input type="text" placeholder="Search AIVOR records" [(ngModel)]="candidateSearchQuery" />
              </div>
              <div class="candidate-search-results">
                <div
                  class="candidate-search-item"
                  *ngFor="let candidate of candidateOptions(row)"
                  [class.claimed]="claimedBy(row, candidate)"
                  (click)="selectCandidate(row, candidate)"
                >
                  <span class="candidate-search-name">{{ candidate.name }}</span>
                  <span class="candidate-search-meta">{{ candidate.meta }}</span>
                  <span class="candidate-search-claimed" *ngIf="claimedBy(row, candidate) as sageName">Matched to {{ sageName }}</span>
                </div>
                <div class="candidate-search-empty" *ngIf="candidateOptions(row).length === 0">
                  {{ candidateSearchQuery ? 'No AIVOR records match that search' : 'Search to pick a different AIVOR record' }}
                </div>
                <div class="candidate-search-empty" *ngIf="candidateMatches(row).length > candidateLimit">
                  Showing {{ candidateLimit }} of {{ candidateMatches(row).length }} — type to narrow the list
                </div>
                <div class="candidate-search-item candidate-search-create" (click)="createAsNew(row)">
                  <i class="bi bi-plus-circle"></i> No match - create as new in AIVOR
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="filteredRows.length === 0">
    <div class="empty-icon"><i class="bi bi-check2-circle"></i></div>
    <div class="empty-title">Nothing left in this view</div>
    <div class="empty-sub">Switch filters above to see the other records.</div>
  </div>
  </ng-container>
  </div>

  <!-- Sticky footer -->
  <div class="sticky-footer" *ngIf="!loadError">
    <div class="footer-progress">
    <div class="footer-text">
      <strong>{{ reviewRemaining }}</strong> still need a decision<span class="d-none d-md-inline"> in {{ entityLabel }}.</span>
    </div>
    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="overallProgressPercent"></div>
    </div>
    </div>
    <div class="footer-actions" [class.without-apply]="!fromConsole">
    <!-- Whole labels: the button is a flex row, so a split label would get the flex gap for spaces. -->
    <button class="btn btn-secondary" (click)="goBack()"><span class="d-none d-md-inline">Save &amp; finish later</span><span class="d-md-none">Save &amp; later</span></button>
    <button class="btn btn-secondary" *ngIf="fromConsole" [disabled]="applyingSession || !syncEnabled || !sessionId" (click)="applySession()">
      {{ applyingSession ? 'Applying…' : 'Apply' }}
    </button>
    <button class="btn btn-teal-gradient" [attr.aria-label]="'Done with ' + entityLabel" (click)="goBack()">
      <span class="d-none d-md-inline">Done with {{ entityLabel }}</span><span class="d-md-none">Done <i class="bi bi-check-lg"></i></span>
    </button>
    </div>
  </div>
</div>

<!-- Outside the page so no scroll box clips it. -->
<div class="modal-backdrop" *ngIf="pendingSyncTarget as pending" (click)="cancelSyncTarget()">
  <div class="modal-card" role="dialog" aria-modal="true" aria-labelledby="sync-target-switch-title" (click)="$event.stopPropagation()">
    <h3 id="sync-target-switch-title">Change how this is sent to Sage?</h3>
    <p>
      {{ pending.row.aivorName }} is already in Sage as {{ syncTarget(pending.row) === 'Bundle' ? 'a bundle' : 'an item' }}.
      A bundle and an item are different records in Sage. The next sync creates the new one, or reuses one sent
      before, and makes the old one inactive in Sage. Any stock the old one holds stays on it in Sage.
    </p>
    <div class="modal-actions">
      <button type="button" class="btn btn-secondary" (click)="cancelSyncTarget()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="confirmSyncTarget()">Change it</button>
    </div>
  </div>
</div>
